import { render, staticRenderFns } from "./HolidayModal.vue?vue&type=template&id=3150129a&"
import script from "./HolidayModal.vue?vue&type=script&lang=js&"
export * from "./HolidayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3150129a')) {
      api.createRecord('3150129a', component.options)
    } else {
      api.reload('3150129a', component.options)
    }
    module.hot.accept("./HolidayModal.vue?vue&type=template&id=3150129a&", function () {
      api.rerender('3150129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/HolidayModal.vue"
export default component.exports